import { AxiosResponse } from 'axios';
import React, { useState, createRef, useEffect } from 'react';
import CustomReCAPTCHA from '../CustomCaptcha';
import { DateObject } from "react-multi-date-picker"
import { TransactionService } from '../../services/TransactionService';
import { ITransaction, ITransactionWebModelRequest } from "../../requests/ITransactionWebModelRequest";
import { TFunction, withTranslation } from 'react-i18next';
import "./TransactionReport.css"
import {
    allOperationTypesFilters,
    allTransactionStatesFilter,
    allResponseCodes,
    allPaymentModesArg,
    allPaymentModesUru
} from "../../models/TransactionReportConstants"
import { Option } from "../../models/Option"
import { WebCache } from "../../services/WebCache";
import { IIssuer } from "../../models/IIssuer";
import ErrorsView from '../ErrorsView';
import { UtilService } from "../../services/UtilService";
import { toast } from 'react-toastify';
import TextField from '../controls/fields/textField';
import NumericField from '../controls/fields/numericField';
import SelectField from '../controls/fields/selectField';
import DateField from '../controls/fields/dateField';
import Button from '../controls/buttons/button';
import { OptionMapperHelper } from '../../helpers/OptionMapperHelper';
import Page from '../containers/page'
import FormFilter from '../containers/form-filter';
import CustomTable, { TableModeEnum } from '../table/CustomTable';
import RadioButtonGroup from '../controls/fields/radioButtonGroup';
import { DateHelper } from '../../helpers/DateHelper';
import NavigationTabLinksForTransactions from './NavigationTabLinksForTransactions';
import FilterFiscalDocumentAndCommerce, { MultiSelectRef } from "../FilterFiscalDocumentAndCommerce";
import { IIssuerTotalDto } from '../../models/IIssuerTotalDto';
import { TransactionColumns } from './TransactionsColumns';
import { useMessages } from "../MessagesContext";
import Pagination from '../Pagination';
import { CurrencyHelper } from '../../helpers/CurrencyHelper';

interface IProps {
    t: TFunction
}

interface IFilters {
    fromDate: DateObject,
    toDate: DateObject,
    fiscalDocument: string[],
    merchantNumber: string[],
    operationTypeFilter: string,
    initQuestionFilter: string,
    groupFilter: string,
    ticketFilter: string,
    batchFilter: string,
    transactionStateFilter: string,
    terminalFilter: string,
    authorizationCodeFilter: string,
    authTerminalFilter: string,
    amountFilter: string,
    amountToCustomerFilter: string,
    transactionIdFilter: string
    cardNumberIdFilter: string,
    muIdFilter: string,
    paymentModeFilter: string,
    acquirerFilter: string,
    issuerFilter: string,
    responseCodeSelected: string | null,
    currencySelected: string | null
}

const pageSize = 20;
const pageQuantity = 3
const defaultPages = [1, 2, 3]
const T_PREFIX: string = 'pages.reportTransactions.';

const RetailReport: React.FC<IProps> = ({ t }: IProps) => {

    const allTransactionStatesFilter = localStorage.getItem("_transactionStatesCode") ? JSON.parse(localStorage.getItem("_transactionStatesCode") as string) : [];
    const allResponseCodes = localStorage.getItem("_transactionResponseCode") ? JSON.parse(localStorage.getItem("_transactionResponseCode") as string) : [];
    const allOperationTypesFilters = localStorage.getItem("_transactionTypesCode") ? JSON.parse(localStorage.getItem("_transactionTypesCode") as string) : [];
    const multiSelectRef = createRef<MultiSelectRef>();

    const buildResponseCodesSelectOptions = (): Array<Option> => {
        let respondCodes: Array<Option> = [
            { value: "", label: t("all"), key: "all" } as Option
        ];
        const responseCodes: Array<HTMLOptionElement> = new OptionMapperHelper(t).buildSelectOptionsFromEnum(allResponseCodes, 'responseCode-') as Array<HTMLOptionElement>;
        respondCodes.push(...responseCodes);
        return respondCodes;
    }

    const buildPaymentModesSelectOptions = (): Array<Option> => {
        let respondCodes: Array<Option> = [
            { value: "", label: t("all"), key: "all" } as Option
        ];

        const allPaymentModes = WebCache.isUserARG() ? allPaymentModesArg : allPaymentModesUru;
        const responseCodes: Array<HTMLOptionElement> = new OptionMapperHelper(t).buildSelectOptionsFromEnum(allPaymentModes, 'channel-') as Array<HTMLOptionElement>;
        respondCodes.push(...responseCodes);
        return respondCodes;
    }

    let [dateFrom, dateTo] = DateHelper.buildDateRange();
    const [filters, setFilters] = useState<IFilters>({ fromDate: dateFrom, toDate: dateTo, operationTypeFilter: "", fiscalDocument: [], initQuestionFilter: "", groupFilter: "", ticketFilter: "", batchFilter: "", transactionStateFilter: "", terminalFilter: "", authorizationCodeFilter: "", authTerminalFilter: "", amountFilter: "", amountToCustomerFilter: "", merchantNumber: [], transactionIdFilter: "", cardNumberIdFilter: "", muIdFilter: "", paymentModeFilter: "", acquirerFilter: "", issuerFilter: "", responseCodeSelected: "", currencySelected: "" });
    const [shouldFetch, setShouldFetch] = useState(false);
    const [activePage, setActivePage] = useState<number>(1);
    const [mainPage, setMainPage] = useState<number>(0);
    const [pages, setPages] = useState<number[]>(defaultPages);
    const [transactions, setTransactions] = useState<ITransaction[]>([]);
    const [currentIssuers, setCurrentIssuers] = useState<IIssuer[]>(WebCache.getAllIssuers());
    const [currencies, setCurrencies] = useState<Option[]>(UtilService.getCurrencyOptions());
    const [isCaptchaVerified, setIsCaptchaVerified] = useState(sessionStorage.getItem('captchaVerified') == "true");
    const [errors, setErrors] = useState<string[]>([]);
    const [issuerByTotal, setIssuerByTotal] = useState<IIssuerTotalDto[]>([])
    const [gridFormat, setGridFormat] = useState<"grid" | "list">("list")
    const [tranId, setTranId] = useState<string>("")
    const [show, setShow] = useState<boolean>(false)
    const [responseCodes, setResponseCodes] = useState<Option[]>(new OptionMapperHelper(t).buildTransactionSelectOptions(allResponseCodes, true))
    const [paymentModes, setPaymentModes] = useState<Option[]>(buildPaymentModesSelectOptions())
    const [maxDayRange, setMaxDayRange] = useState<number>(15)
    const messages = useMessages();

    const handleCaptchaVerify = (onVerify: boolean) => {
        setIsCaptchaVerified(onVerify);
    };

    const getTransactionRequest = (all: boolean) => {
        let from_year: number;
        let from_month: number;
        let from_day: number;
        let to_year: number;
        let to_month: number;
        let to_day: number;
        from_year = filters.fromDate.year;
        from_month = filters.fromDate.month.number;
        from_day = filters.fromDate.day;
        to_year = filters.toDate.year;
        to_month = filters.toDate.month.number;
        to_day = filters.toDate.day;
        const getIdOfFilter = (value: string) => {// Obtiene el id del filtro de transaccion seleccionado, este separado por "-"
            return value === "" ? value : value.split("-")[1];
        };

        const tranWebModel: ITransactionWebModelRequest = {
            From: new Date(from_year, from_month - 1,
                from_day,
                filters.fromDate.hour - 3,
                filters.fromDate.minute).toJSON(),
            To: new Date(to_year,
                to_month - 1,
                to_day,
                filters.toDate.hour - 3,
                filters.toDate.minute).toJSON(),
            Terminals: (filters.terminalFilter == null || filters.terminalFilter == "") ? [] : ["B24_" + filters.terminalFilter, filters.terminalFilter], // todo falta filtrar las terminales del usuario
            TransactionState: (filters.transactionStateFilter == null || filters.transactionStateFilter == "") ? [] : filters.transactionStateFilter.split("-").map(Number),
            TerminalGroup: (filters.groupFilter == null || filters.groupFilter == "") ? "" : filters.groupFilter,
            InitQuestion: (filters.initQuestionFilter == null || filters.initQuestionFilter == "") ? "" : filters.initQuestionFilter,
            OperationType: (filters.operationTypeFilter == null) ? "" : (getIdOfFilter(filters.operationTypeFilter)),
            AuthTerminal: (filters.authTerminalFilter == null || filters.authTerminalFilter == "") ? "" : filters.authTerminalFilter,
            Amount: (filters.amountFilter == null || filters.amountFilter == "") ? "" : filters.amountFilter,
            AmountToCustomer: (filters.amountToCustomerFilter == null || filters.amountToCustomerFilter == "") ? "" : filters.amountToCustomerFilter,
            AuthorizationCode: (filters.authorizationCodeFilter == null || filters.authorizationCodeFilter == "") ? "" : filters.authorizationCodeFilter,
            Issuer: (filters.issuerFilter == null || filters.issuerFilter == "0000") ? "" : filters.issuerFilter,
            PayerTaxIds: filters.fiscalDocument.includes("all") ? [] : filters.fiscalDocument.filter(x => x.length > 0),
            MerchantCodes: filters.merchantNumber.includes("all") ? [] : filters.merchantNumber.filter(x => x.length > 0),
            Department: "",
            Location: "",
            Branch: "",
            Acquirer: (filters.acquirerFilter == null || filters.acquirerFilter == "0000") ? "" : filters.acquirerFilter,
            TransactionId: (filters.transactionIdFilter == null || filters.transactionIdFilter == "") ? "" : filters.transactionIdFilter,
            CardNumber: (filters.cardNumberIdFilter == null || filters.cardNumberIdFilter == "") ? "" : filters.cardNumberIdFilter,
            MuId: (filters.muIdFilter == null || filters.muIdFilter == "") ? "" : filters.muIdFilter,
            TicketNumber: (filters.ticketFilter == null || filters.ticketFilter == "") ? "" : filters.ticketFilter,
            BatchNumber: (filters.batchFilter == null || filters.batchFilter == "") ? "" : filters.batchFilter,
            PaymentMode: (filters.paymentModeFilter == null || filters.paymentModeFilter == "") ? "" : filters.paymentModeFilter,
            Skip: all ? 0 : (mainPage * pageSize * pageQuantity),
            Take: all ? 0 : ((pageSize * pageQuantity) + 1),
            Currency: filters.currencySelected,
            ResponseCode: (filters.responseCodeSelected == null || filters.responseCodeSelected == "") ? "" : (getIdOfFilter(filters.responseCodeSelected)),
        };
        return tranWebModel;
    }

    const getTransactions = () => {


        let dateFrom = DateHelper.dateObjectToDate(filters.fromDate);
        let dateTo = DateHelper.dateObjectToDate(filters.toDate);
        let diffDays = Math.round((dateTo.getTime() - dateFrom.getTime()) / (1000 * 3600 * 24));
        if (diffDays > maxDayRange) {
            toast.error(`La busqueda no puede superar los ${maxDayRange} días`);
            return;
        }

        TransactionService.getAllMinoristTransactions(getTransactionRequest(false)).then((response: AxiosResponse<ITransaction[]>) => {
            if (response == null || response.data == null || response.data.length == 0) {
                setTransactions([]);
                setErrors([])
            }
            setTransactions(response.data)
            setErrors([])
        }).catch(error => {
            setErrors(error.response.data)
            console.log('error:', error);
        }
        );
    }
    const getFromBuscar = () => {
        setActivePage(1)
        setPages(defaultPages)
        setMainPage(0)
        getTransactions()
    }

    const getTicket = (tranId: string, transactionType: string) => {
        TransactionService.showTicket(tranId, transactionType)
    }

    const clearFilters = () => {
        // se hace un clearFilter desde la referencia del multiselect
        multiSelectRef.current?.clearFilters();
        setFilters({
            ...filters,
            fromDate: dateFrom,
            toDate: dateTo,
            operationTypeFilter: "",
            initQuestionFilter: "",
            groupFilter: "",
            ticketFilter: "",
            batchFilter: "",
            transactionStateFilter: "",
            terminalFilter: "",
            authorizationCodeFilter: "",
            authTerminalFilter: "",
            amountFilter: "",
            amountToCustomerFilter: "",
            merchantNumber: [""],
            transactionIdFilter: "",
            cardNumberIdFilter: "",
            muIdFilter: "",
            paymentModeFilter: "",
            acquirerFilter: "",
            issuerFilter: "",
            fiscalDocument: [""],
            responseCodeSelected: "",
            currencySelected: ""
        });
        setShouldFetch(true); // Marca que hay que hacer fetch
    }
    //obtiene valores predeterminados cuando se hace clearFilters
    useEffect(() => {
        if (shouldFetch) {
            getFromBuscar();
            setShouldFetch(false); // Resetea la bandera
        }
    }, [filters, shouldFetch]);

    const getTransactionsToExcel = () => {
        if (isCaptchaVerified) {
            messages.showDownloadMessage();
            TransactionService.getAllToExcel(getTransactionRequest(true))
                .then((response: AxiosResponse<Blob>) => {
                })
                .catch((error) => {
                    setErrors(error.response.data)
                    console.log('error:', error);
                });
        } else {
            toast.error("Por favor, verifica el CAPTCHA antes de descargar el archivo");
        }
    };

    const getTotalsByIssuerAndCurrency = (tranId: string) => {
        TransactionService.getTotalsByIssuerAndCurrency(tranId).then((response: AxiosResponse<IIssuerTotalDto[]>) => {
            setShow(true)
            setIssuerByTotal(response.data)
            setTranId(tranId)
        }).catch(error => console.log('error:', error));
    }

    const processAction = (event: any, transaction: ITransaction) => {
        event.preventDefault();
        getTotalsByIssuerAndCurrency(transaction.id);
    }

    const transactionColumns = TransactionColumns({
        t,
        processAction,
        getTicket,
        showCouponColumn: true
    });


    const buildIssuerSelectOptions = () => {
        let options: Array<HTMLOptionElement> = new OptionMapperHelper(t).buildSelectOptionsFromAnArrayWithDifferentInterface(currentIssuers, 'id', 'issuerName') as Array<HTMLOptionElement>;
        const todosIndex = options.findIndex(option => option.value === '0000');

        if (todosIndex !== -1) {
            const todosOption = options.splice(todosIndex, 1)[0];
            options = [todosOption, ...options];
        }
        options.sort((a, b) => {
            if (a.label === 'Todos') return -1;
            if (b.label === 'Todos') return 1;
            return a.label.localeCompare(b.label);
        });
        return options;
    }

    return (
        <Page>
            <>
                <h2>{t(`sales`)}</h2>
                <div className='row'>
                    <div className='col-lg-12'>
                        <ErrorsView errors={errors} />
                    </div>
                </div>
                <div className="row">
                    <div className="col-lg-12">
                        <div className="card-header">
                            <NavigationTabLinksForTransactions></NavigationTabLinksForTransactions>
                        </div>
                        <div className="card-body">
                            <FormFilter
                                onSubmit={() => getFromBuscar()}
                                model={[filters, setFilters]}
                                hidden={UtilService.isMobilePlatform() ? true : false}

                                clear={() => clearFilters()}
                                header={
                                    <div className="d-flex align-items-center justify-content-end">
                                        <button
                                            className={`btn ${gridFormat === "list" ? "btn-primary" : "btn-outline-primary"} me-2`}
                                            onClick={() => setGridFormat("list")}
                                        >
                                            <i className="fe fe-list"></i> {t("")}
                                        </button>
                                        <button
                                            className={`btn ${gridFormat === "grid" ? "btn-primary" : "btn-outline-primary"}`}
                                            onClick={() => setGridFormat("grid")}
                                        >
                                            <i className="fe fe-grid"></i> {t("")}
                                        </button>
                                    </div>
                                }
                            >
                                <>
                                    <div className="row">
                                        <div className="col-md-3">
                                            <DateField attr='fromDate' label={t(`${T_PREFIX}authDateTimeFrom`)} required={true}></DateField>
                                        </div>
                                        <div className="col-md-3">
                                            <DateField attr='toDate' label={t(`${T_PREFIX}authDateTimeTo`)} required={true}></DateField>
                                        </div>
                                        <div className="col-md-3">
                                            <SelectField attr='operationTypeFilter' label={t(`${T_PREFIX}transactionType`)} options={new OptionMapperHelper(t).buildTransactionSelectOptions(allOperationTypesFilters, false)}></SelectField>
                                        </div>
                                        <div className="col-md-3">
                                            <SelectField attr='transactionStateFilter' label={t(`${T_PREFIX}state`)} options={new OptionMapperHelper(t).buildTransactionSelectOptions(allTransactionStatesFilter, false, true)}></SelectField>
                                        </div>
                                        <div className="col-md-3">
                                            <SelectField attr='issuerFilter' label={t(`${T_PREFIX}issuer`)} options={buildIssuerSelectOptions()}></SelectField>
                                        </div>
                                        <div className="col-md-3">
                                            <TextField attr='terminalFilter' label={t(`${T_PREFIX}terminal`)}></TextField>
                                        </div>
                                        <FilterFiscalDocumentAndCommerce
                                            ref={multiSelectRef}
                                            columnClassName={"col-md-3"}
                                            changeFilter={(fiscalDocument, merchantNumber) => {
                                                setFilters({
                                                    ...filters,
                                                    merchantNumber: merchantNumber,
                                                    fiscalDocument: fiscalDocument
                                                });
                                            }}
                                            includeAllFiscalDocument={true}
                                            includeWholesaler={true}
                                            includeOnlyWholesaler={true}
                                        />
                                        <div className="col-md-3">
                                            <NumericField attr='amountFilter' label={t(`${T_PREFIX}amount`)}></NumericField>
                                        </div>
                                        <div className="col-md-3">
                                            <TextField attr='authorizationCodeFilter'
                                                label={t(`${T_PREFIX}authorizationCode`)}></TextField>
                                        </div>
                                        <div className="col-md-3">
                                            <TextField attr='transactionIdFilter' label={t(`${T_PREFIX}id`)}></TextField>
                                        </div>
                                        <div className="col-md-3">
                                            <SelectField attr='currencySelected' label={t(`${T_PREFIX}currency`)}
                                                options={currencies}
                                                disabled={currencies.length == 1}></SelectField>
                                        </div>
                                        <div className="col-md-3">
                                            <TextField attr='cardNumberIdFilter' label={t(`${T_PREFIX}cardNumber`)}></TextField>
                                        </div>
                                        <div className="col-md-3">
                                            <SelectField attr="responseCodeSelected" label={t(`${T_PREFIX}responseCode`)}
                                                options={responseCodes}></SelectField>
                                        </div>
                                        <div className="col-md-3">
                                            <TextField attr='ticketFilter' label={t(`${T_PREFIX}ticket`)}></TextField>
                                        </div>
                                        <div className="col-md-3">
                                            <TextField attr='batchFilter' label={t(`${T_PREFIX}batch`)}></TextField>
                                        </div>
                                        <><div className="col-md-3">
                                            <SelectField attr="paymentModeFilter" label={t(`${T_PREFIX}paymentMode`)} options={paymentModes}></SelectField>
                                        </div>
                                            <div className="col-md-3">
                                                <TextField attr='muIdFilter' label={t(`${T_PREFIX}muId`)} ></TextField>
                                            </div>
                                        </>
                                    </div>
                                </>
                            </FormFilter>
                            <div className='row'>
                                <div className="col-md-12">
                                    {UtilService.isMobilePlatform() ?
                                        <div>
                                            <div className="container">
                                                <ul className="notification">
                                                    {
                                                        transactions.slice(pages.indexOf(activePage) * pageSize, (pages.indexOf(activePage) * pageSize) + pageSize).map((transaction, Tindex) => {
                                                            return (
                                                                <li>
                                                                    <div className="notification-time-date mb-2 d-block d-md-none">
                                                                        <span className="date">{transaction.authDateTime}</span>
                                                                    </div>
                                                                    <div className={"settlementMobile notification-body transactionType-" + transaction.transactionType}>
                                                                        <div className="media mt-0">
                                                                            <div className="main-avatar avatar-md online" >
                                                                                {<img alt="avatar" className="br-7 transaction-image" src={UtilService.getImageTag(t("issuer-" + transaction.issuer).toUpperCase())}></img>
                                                                                }
                                                                            </div>
                                                                            <div className="media-body ms-3 d-flex">
                                                                                <div className="" >
                                                                                    <span className={transaction.transactionType == "REV" || transaction.transactionType == "LP" || transaction.transactionType == "A" || transaction.transactionType == "D" ? "text-danger amount-label" : "amount-label"}>{Intl.NumberFormat('es-UY', {
                                                                                        style: 'currency',
                                                                                        currency: CurrencyHelper.getCurrencySymbol(transaction.currency)
                                                                                    }).format(transaction.totalAmountForReport)}</span>
                                                                                    <p className="mb-0 fs-13 text-muted">{t("transactionType-" + transaction.transactionType)}</p>
                                                                                    <p className="mb-0 fs-13 text-muted">{transaction.cardNumber}</p>
                                                                                    <p className={"mb-0 fs-11 " + (transaction.responseCode == "00" ||
                                                                                        transaction.responseCode == "08" ||
                                                                                        transaction.responseCode == "11" ||
                                                                                        transaction.responseCode == "85" ||
                                                                                        transaction.responseCode == "LV" ||
                                                                                        transaction.responseCode == "OF" ? "response-code-success" : "response-code-error")}>{t("responseCode-" + transaction.responseCode)}</p>
                                                                                </div>
                                                                            </div>
                                                                            <div style={{ width: "34px", height: "30px", marginLeft: "10px" }}>
                                                                                <a onClick={() => { getTicket(transaction.id, transaction.transactionType) }}>
                                                                                    <i className="fa-sharp fa-solid fa-print text-primary" aria-hidden="true"></i>
                                                                                </a>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </li>
                                                            )
                                                        })}
                                                </ul>
                                            </div>
                                            <div>
                                                <Pagination
                                                    pageSize={pageSize}
                                                    pageQuantity={pageQuantity}
                                                    modifyMainPage={(value: number, newPages: Array<number>) => {
                                                        setMainPage(mainPage + value);
                                                        setPages(newPages);
                                                        getTransactions();
                                                    }}
                                                    changePage={(page: number) => setActivePage(page)}
                                                    dataL={transactions.length}
                                                    mainPage={mainPage}
                                                ></Pagination>
                                            </div>
                                        </div>
                                        :
                                        <CustomTable
                                            rowObjects={transactions}
                                            columnDefinitions={transactionColumns}
                                            config={{
                                                pageSize: pageSize,
                                                mode: gridFormat === "list" ? TableModeEnum.LIST : TableModeEnum.GRID,
                                                paginator: {
                                                    quantity: pageQuantity,
                                                    mainPage: mainPage,
                                                    modifyMainPage: (value: number) => {
                                                        setMainPage(mainPage + value);
                                                        getTransactions();
                                                    },
                                                    pageRequest: {
                                                        Skip: 0,
                                                        Take: 0
                                                    }
                                                },
                                            }}
                                        ></CustomTable>}
                                </div>
                            </div>
                        </div>
                        <div className='row'>
                            <div className='col-md-6'></div>
                            <div className="col-md-3">
                                <CustomReCAPTCHA useCache={true} onVerify={handleCaptchaVerify} />
                            </div>
                            <div className="col-md-3">
                                <Button disabled={transactions.length === 0} label='excel' onClick={() => getTransactionsToExcel()}></Button>
                            </div>
                        </div>
                    </div>
                </div>
                <>
                </>
            </>
        </Page>
    );
}
export default withTranslation()(RetailReport); 
